import * as m from "../es2015/maps";
window.am4maps = m;


//////////////////
// WEBPACK FOOTER
// ./maps.js
// module id = null
// module chunks = 